import React from 'react';

export type PhoneLinkProps = {
    className?: string;
    value: string;
    areaSeparator?: string;
    numberSeparator?: string;
};

const PhoneLink: React.FC<PhoneLinkProps> = props => {
    const { className, value, children, areaSeparator = ' ', numberSeparator = '-' } = props;
    const href = value.replace(/\s|-|\(|\)/g, '');
    const areaCode = href.substr(0, 2);
    const numberArr = [href.substr(2, 3), href.substr(5, 3), href.substr(8, 4)]

    return (
        <a className={className} href={`tel:${href}`}>
            {children || `${areaCode}${areaSeparator}${numberArr.join(numberSeparator)}`}
        </a>
    )
};

export default PhoneLink;